angular.module("roles")

    .controller("RolesListCtrl", ['LoginService', '$rootScope', '$scope', '$http', '$interval', '$q', 'i18nService', 'Restangular', 'gridService', 'modalService', '$filter', '$state', 'logService',
        function (LoginService, $rootScope, $scope, $http, $interval, $q, i18nService, Restangular, gridService, modalService, $filter, $state, logService) {
        
        //Comprobamos si tiene permiso escritura
        $scope.allowWrite = LoginService.permissionExist("ROLES_WRITE");

        $rootScope.title = $filter("translate")("roles.title");
        $rootScope.breadcrumb = [
            { title: $filter("translate")("roles.list") }
        ];

        i18nService.setCurrentLang('es');
        var fakeI18n = function (title) {
            var deferred = $q.defer();
            $interval(function () {
                deferred.resolve('col: ' + title);
            }, 1000, 1);
            return deferred.promise;
        };


        $scope.gridOptions = {
            exporterMenuCsv: true,
            enableGridMenu: true,
            //gridMenuShowHideColumns: false,
            pdfTitle: $filter("translate")("roles.title"),
            paginationPageSizes: [5, 10, 25],
            paginationPageSize: 5,
            rowTemplate: '<div ng-dblclick="grid.appScope.goToEdit(row.entity)" ng-repeat="(colRenderIndex, col) in colContainer.renderedColumns track by col.uid" class="ui-grid-cell" ng-class="col.colIndex()" ui-grid-cell style="cursor:pointer;"></div>',
            onRegisterApi: function (gridApi) {
                this.gridApi = gridApi;
            },
            columnDefs: [
              { name: 'id', visible: false, exporterSuppressExport: true },
              { name: 'code', displayName: $filter("translate")("roles.code"), enableFiltering: true },
              { name: 'name', displayName: $filter("translate")("roles.name"), enableFiltering: true, enableHiding: false },
              { name: 'description', enableFiltering: true, displayName: $filter("translate")("roles.description") },
              {
                  name: ' ', width: 150, exporterSuppressExport: true, enableSorting: false, enableHiding: false, enableFiltering: false, enableColumnMenu: false, cellTemplate: gridService.actionTemplate([
                      { title: $filter("translate")("roles.edit"), action: 'ui-sref="roles.edit({id:row.entity.id})"', cssIconClass: "fa fa-edit" },
                      { title: $filter("translate")("roles.delete"), action: 'ng-click="grid.appScope.BorrarDialog(row.entity.id,row.entity.name);" ng-if="grid.appScope.allowWrite"', cssIconClass: "fa fa-remove" }
                  ], { cssClass: "pull-right"})
              },
              //'<div class="ui-grid-cell-contents ng-scope" style="margin:0 auto;text-align:center;"><a class="btn btn-xs btn-primary" ui-sref="persons_types.edit({id: row.entity.id})" "><i class="fa fa-pencil"></i>Editar</a></div>'
            ],
            getData: function (options) {
                return Restangular.all('Roles').getList(options);
            }

        };

        $scope.goToEdit = function (rowEntity) {
            $state.go("roles.edit", { id: rowEntity.id });
        }


        $scope.BorrarDialog = function (id, name) {
            $scope.id = id;
            $scope.name = name;
            modalService.confirm({
                title: $filter("translate")("roles.delete"),
                message: $filter("translate")("roles.delete_message")+" " + $scope.name + "?",
                onAccept: function () {
                    Restangular.one('Roles', $scope.id).remove().then(function () {                        
                        $scope.gridOptions.data =
                             $scope.gridOptions.data.filter(function (el) { return el.id != $scope.id; });
                    }, function (response) {
                        logService.error("Error with status code", response.status);
                        alert("Error al borrar")
                    });
                }
            });

        };
    }])

;